import { useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useAppDispatch } from 'state/hooks'

import { updateUserDarkMode } from '../state/user/actions'

export default function DarkModeQueryParamReader({ location: { search } }: RouteComponentProps): null {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(updateUserDarkMode({ userDarkMode: true }))
  }, [dispatch, search])

  return null
}
